import { useOutletContext } from "react-router-dom";
import { Remediation } from "~/components/Remediation/Remediation";
import { Initiative } from "~/operations";
import { SpaceOrWorkspaceScope, SpaceScope } from "~/hooks/useScope";
import { Typography } from "@mui/material";

interface InitiativeDetailOutletContext {
  initiative: Initiative;
  scope: SpaceOrWorkspaceScope;
  spaceScope: SpaceScope;
}

export function InitiativeRemediationsTab() {
  const { initiative, scope } =
    useOutletContext<InitiativeDetailOutletContext>();

  const references = initiative.references || [];

  if (references.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary">
        No remediations found.
      </Typography>
    );
  }

  const packages = references
    .filter((ref) => ref?.findingMrn)
    .map((ref) => ref.findingMrn.split("/").pop() || "")
    .filter((findingId) => Boolean(findingId))
    .map((findingId) => ({
      name: findingId,
    }));

  return (
    <Remediation
      packages={packages}
      scopeMrn={scope.mrn}
      showHeader={false}
      initiativeMrn={initiative.mrn}
    />
  );
}
